(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["content-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function applyOverlap() {
      document.querySelectorAll('.content-grid[data-overlap]').forEach(function (el) {
        var wrapper = el.closest('.content-grid-section') || el;
        var pct = parseFloat(el.dataset.overlap) || 0;
        if (pct <= 0) {
          wrapper.style.marginBlockStart = '30px';
          return;
        }
        // Interpolación: 0% = 30px de margen, 50% = superponerse la mitad de la altura
        var t = pct / 50;
        var margin = 30 * (1 - t) - el.offsetHeight * (pct / 100);
        wrapper.style.marginBlockStart = margin + 'px';
      });
    }

    var scheduled = false;
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        applyOverlap();
      });
    }

    window.addEventListener('load', applyOverlap);
    window.addEventListener('resize', schedule);
    document.addEventListener('shopify:section:load', applyOverlap);

    if ('ResizeObserver' in window) {
      var observer = new ResizeObserver(schedule);
      document.querySelectorAll('.content-grid[data-overlap]').forEach(function (el) {
        observer.observe(el);
      });
    }

    applyOverlap();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["expo-benefits"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialized = new WeakSet();

    const init = (root) => {
      if (!root || initialized.has(root)) return;
      initialized.add(root);

      const tabs = Array.from(root.querySelectorAll('[data-benefit-tab]'));
      const panels = Array.from(root.querySelectorAll('[data-benefit-panel]'));
      const section = root.closest('.expo-benefits');
      const desktopCards = section ? Array.from(section.querySelectorAll('[data-benefit-card]')) : [];
      const desktopGrid = section ? section.querySelector('[data-benefits-carousel]') : null;
      const previousButton = section ? section.querySelector('[data-benefit-prev]') : null;
      const nextButton = section ? section.querySelector('[data-benefit-next]') : null;
      let benefitsPage = 0;
      const benefitsPageCount = Math.max(1, Math.ceil(desktopCards.length / 4));
      let autoplayTimer = null;
      let autoplayStopped = false;

      const renderBenefitsPage = () => {
        const firstVisible = benefitsPage * 4;
        desktopCards.forEach((card, index) => {
          card.setAttribute('aria-hidden', String(index < firstVisible || index >= firstVisible + 4));
        });
      };

      const changeBenefitsPage = (direction) => {
        if (!desktopGrid) return;
        benefitsPage = (benefitsPage + direction + benefitsPageCount) % benefitsPageCount;
        renderBenefitsPage();
      };

      const stopAutoplay = () => {
        autoplayStopped = true;
        if (autoplayTimer) window.clearInterval(autoplayTimer);
        autoplayTimer = null;
      };

      const startAutoplay = () => {
        if (
          autoplayStopped ||
          autoplayTimer ||
          benefitsPageCount < 2 ||
          !window.matchMedia('(min-width: 981px)').matches ||
          window.matchMedia('(prefers-reduced-motion: reduce)').matches
        ) return;
        autoplayTimer = window.setInterval(() => changeBenefitsPage(1), 7000);
      };

      if (previousButton) previousButton.addEventListener('click', () => {
        stopAutoplay();
        changeBenefitsPage(-1);
      });
      if (nextButton) nextButton.addEventListener('click', () => {
        stopAutoplay();
        changeBenefitsPage(1);
      });
      renderBenefitsPage();
      startAutoplay();

      const activate = (index, moveFocus = false) => {
        tabs.forEach((tab, tabIndex) => {
          const active = tabIndex === index;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          if (active && moveFocus) tab.focus();
        });
        panels.forEach((panel, panelIndex) => { panel.hidden = panelIndex !== index; });
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(index));
        tab.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let next = index;
          if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = tabs.length - 1;
          else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + tabs.length) % tabs.length;
          else next = (index + 1) % tabs.length;
          activate(next, true);
        });
      });
      activate(0);
    };

    document.querySelectorAll('[data-benefits-tabs]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-benefits-tabs]').forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["expo-coundown-lcd"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-expo-countdown-lcd]';
    const intervals = new WeakMap();
    const pad = (value) => String(value).padStart(2, '0');

    function init(root) {
      if (!root || intervals.has(root)) return;

      const target = Date.parse(root.dataset.target || '');
      const fields = {
        days: root.querySelector('[data-lcd-days]'),
        hours: root.querySelector('[data-lcd-hours]'),
        minutes: root.querySelector('[data-lcd-minutes]'),
        seconds: root.querySelector('[data-lcd-seconds]')
      };

      if (!Number.isFinite(target) || Object.values(fields).some((field) => !field)) return;

      const render = () => {
        const remaining = Math.max(0, target - Date.now());
        const total = Math.floor(remaining / 1000);

        fields.days.textContent = pad(Math.floor(total / 86400));
        fields.hours.textContent = pad(Math.floor((total % 86400) / 3600));
        fields.minutes.textContent = pad(Math.floor((total % 3600) / 60));
        fields.seconds.textContent = pad(total % 60);

        if (remaining === 0) {
          const message = root.querySelector('[data-lcd-expired]');
          if (message && root.dataset.expiredMessage) {
            message.textContent = root.dataset.expiredMessage;
            message.hidden = false;
          }
          clearInterval(intervals.get(root));
          intervals.delete(root);
        }
      };

      render();
      intervals.set(root, window.setInterval(render, 1000));
    }

    document.querySelectorAll(selector).forEach(init);
    document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector(selector)));
    document.addEventListener('shopify:section:unload', (event) => {
      const root = event.target.querySelector(selector);
      if (root && intervals.has(root)) {
        clearInterval(intervals.get(root));
        intervals.delete(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["expo-countdown"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-expo-countdown]';
    const intervals = new WeakMap();

    function pad(value) { return String(value).padStart(2, '0'); }

    function init(root) {
      if (!root || intervals.has(root)) return;
      const target = Date.parse(root.dataset.target || '');
      const fields = {
        days: root.querySelector('[data-days]'), hours: root.querySelector('[data-hours]'),
        minutes: root.querySelector('[data-minutes]'), seconds: root.querySelector('[data-seconds]')
      };
      if (!Number.isFinite(target) || Object.values(fields).some((field) => !field)) return;

      const render = () => {
        const remaining = Math.max(0, target - Date.now());
        const total = Math.floor(remaining / 1000);
        fields.days.textContent = pad(Math.floor(total / 86400));
        fields.hours.textContent = pad(Math.floor((total % 86400) / 3600));
        fields.minutes.textContent = pad(Math.floor((total % 3600) / 60));
        fields.seconds.textContent = pad(total % 60);
        if (remaining === 0) {
          const message = root.querySelector('[data-expired]');
          if (message && root.dataset.expiredMessage) { message.textContent = root.dataset.expiredMessage; message.hidden = false; }
          clearInterval(intervals.get(root)); intervals.delete(root);
        }
      };
      render(); intervals.set(root, window.setInterval(render, 1000));
    }

    document.querySelectorAll(selector).forEach(init);
    document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector(selector)));
    document.addEventListener('shopify:section:unload', (event) => {
      const root = event.target.querySelector(selector);
      if (root && intervals.has(root)) { clearInterval(intervals.get(root)); intervals.delete(root); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["expo-navbar-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-expo-navbar-v2]';
    const initialized = new WeakSet();

    const init = (root) => {
      if (!root || initialized.has(root)) return;
      const toggle = root.querySelector('[data-navbar-v2-toggle]');
      const menu = root.querySelector('[data-navbar-v2-menu]');
      if (!toggle || !menu) return;
      const openLabel = toggle.dataset.openLabel || 'Abrir menú';
      const closeLabel = toggle.dataset.closeLabel || 'Cerrar menú';
      const close = () => {
        root.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-label', openLabel);
      };
      const updateScrolledState = () => root.classList.toggle('is-scrolled', window.scrollY > 28);
      toggle.addEventListener('click', () => {
        const open = root.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', String(open));
        toggle.setAttribute('aria-label', open ? closeLabel : openLabel);
      });
      menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', close));
      root.addEventListener('keydown', (event) => { if (event.key === 'Escape') { close(); toggle.focus(); } });
      window.addEventListener('scroll', updateScrolledState, { passive: true });
      updateScrolledState();
      initialized.add(root);
    };

    document.querySelectorAll(selector).forEach(init);
    document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector(selector)));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["expo-navbar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-expo-navbar]';
    const initialized = new WeakSet();

    function init(root) {
      if (!root || initialized.has(root)) return;
      const toggle = root.querySelector('[data-navbar-toggle]');
      const menu = root.querySelector('[data-navbar-menu]');
      if (!toggle || !menu) return;
      const close = () => { root.classList.remove('is-open'); toggle.setAttribute('aria-expanded', 'false'); toggle.setAttribute('aria-label', 'Abrir menú'); };
      toggle.addEventListener('click', () => {
        const open = root.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', String(open));
        toggle.setAttribute('aria-label', open ? 'Cerrar menú' : 'Abrir menú');
      });
      menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', close));
      initialized.add(root);
    }
    document.querySelectorAll(selector).forEach(init);
    document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector(selector)));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
